import { memo } from "react";

import { useGetSingleRouteDetails } from "../../../../hooks";
import { MainRouteWithFormValidator } from "../../../../router/types";
import { createSingleRoute } from "../SingleRoute";

type ConnectedSingleRouteProps = {
  readonly children: number;
  readonly currentRoute: string;
  readonly route: MainRouteWithFormValidator;
};

export const ConnectedSingleRoute = memo<ConnectedSingleRouteProps>(
  ({ children, currentRoute, route }) => {
    const { formValidatedSelector, path } = route;
    const {
      isDestinationRouteActive,
      isDestinationRouteValidated,
      onClickHandler,
    } = useGetSingleRouteDetails(formValidatedSelector, currentRoute, path);

    return createSingleRoute({
      ...route,
      children,
      currentRoute,
      isActive: isDestinationRouteActive,
      isValidated: isDestinationRouteValidated,
      onClickHandler,
    });
  }
);
